export default __webpack_public_path__ + "static/media/TV_M239_04.c5a129f9.png";